<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <h2 class="cf-title cf-title--2">
      {{ tableNumberContent }}
    </h2>

    <cf-validated-form
      name="enterTableNumberForm"
      @valid-submit="handleSubmitTableNumber"
    >
      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <cf-text-input
          v-model="tableNumber"
          type="text"
          auto-width
          :label="`${userLocationType.description} #`"
          class="auto-spacing-left auto-spacing-right"
          :icon-class="userLocationType.icon || 'fa-utensils'"
          name="tableNumber"
          :validations="{
            required: true,
            alpha_num: true,
          }"
        />

        <button
          :class="['cf-button cf-button--primary cf-button--lg cf-button--fill', { 'cf-button--loading': isLoading }]"
          type="submit"
        >
          Submit
        </button>
      </div>
    </cf-validated-form>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'EnterTableNumber',

    components: {
      CfValidatedForm,
      CfTextInput
    },

    data() {
      return {
        tableNumber: null,
        isLoading: false
      };
    },

    computed: {
      ...mapGetters('orders', ['userLocationType']),

      tableNumberContent() {
        return `Enter your ${this.userLocationType.description.toLowerCase()} number below:`;
      }
    },

    methods: {
      async handleSubmitTableNumber() {
        try {
          this.isLoading = true;

          await this.$store.dispatch('session/updateRouteParamsDirectly', {
            tableNumber: this.tableNumber
          });

          this.$closeModal('enterTableNumberModal');
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.isLoading = false;
        }
      }
    }
  };
</script>
